/* eslint-disable react-hooks/rules-of-hooks */
import { Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useSettings } from '../../@core/hooks/useSettings'
import Tab from '@mui/material/Tab'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import { styled } from '@mui/material/styles'
import MuiTabList from '@mui/lab/TabList'
import Upload from '../../component/ui/upload/Upload'
import Pending from '../../component/ui/upload/Pending'
import Completed from '../../component/ui/upload/Completed'
import History from '../../component/ui/upload/History'
import Reports from '../../component/ui/upload/Reports'
import Search from '../../component/ui/upload/Search'

import { convertToUnixTimestamp } from '../../component/functions/isoToNumberFormate'
import { userData } from '../../hooks/userData'
import UploadZip from '../../component/ui/upload/Upload_zip'
import { useUploadFiles } from '../../hooks/uploadFiles'
import { showSnackbar } from '../../component/ui/toast/snackbarService'
import Upload_excel from '../../component/ui/upload/upload-excel'

const TabList = styled(MuiTabList)(({ theme }) => ({
    borderBottom: '0 !important',
    '&, & .MuiTabs-scroller': {
        boxSizing: 'content-box',
        padding: theme.spacing(1.25, 1.25, 2),
        margin: theme.spacing(-1.25, -1.25, -2)
    },
    '& .MuiTabs-indicator': {
        display: 'none'
    },
    '& .Mui-selected': {
        color: theme.palette.common.main, // Adding !important
        borderBottom: '2px solid'
    },
    '& .MuiTab-root': {
        lineHeight: 1,
        '&:hover': {
            color: theme.palette.primary.main
        }
    },
    '& .MuiTabs-flexContainer': {
        // backgroundColor: 'red',
        justifyContent: 'center',
        borderBottom: `1px solid #2f2b3d29`
    },
}))

const index = () => {
    // ** Hooks
    const theme = useTheme()
    const gst_claim = userData()
    const tc_upload = useUploadFiles()

    const { settings } = useSettings()
    const [value, setValue] = useState('upload_zip')
    const [selectedClaim, setSelectedClaim] = useState(null);
    const [selectedAccount, setSelectedAccount] = useState(null);
    const [startDateRange, setStartDateRange] = useState(new Date())
    const [endDateRange, setEndDateRange] = useState(new Date())
    const [selectedAccountType, setSelectedAccountType] = useState({ type: 'platform Email', value: 'meesho' });
    const [userList, setUserList] = useState([])
    const [date, setDate] = useState(new Date())




    useEffect(() => {
        tc_upload.setPendingRecord(null)
        tc_upload.setCompletedRecord(null)
        tc_upload.setHistoryRecord(null)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value])

    const handleChange = (event, newValue) => {
        setValue(newValue)
    }

    // ** Vars
    const { skin } = settings

    const handleOnChange = dates => {
        const [start, end] = dates
        setStartDateRange(start)
        setEndDateRange(end)
    }

    const handleSubmitReport = () => {
        let payload = { selectedAccountType: selectedAccountType.value, selectedClaim: selectedClaim ? selectedClaim.value : '', selectedAccount: selectedAccount ? selectedAccount.id : '' }
        const { startTimestamp, endTimestamp } = convertToUnixTimestamp(startDateRange, endDateRange)
        let orderDate = { endDate: endTimestamp, startDate: startTimestamp }
        payload['orderDate'] = orderDate
        showSnackbar("Thank you for good Joke", "success");

        const recordFunctions = {
            pending: tc_upload.getPendingRecord,
            completed: tc_upload.getCompletedRecord,
            history: tc_upload.getHistoryRecord,
            reports: tc_upload.getReportsRecord,
        };

        if (recordFunctions[value]) {
            // recordFunctions[value](payload, (response) => {
            //   const message = response.status === "success"
            //     ? "Record Upload successfully!"
            //     : "Something Went Wrong";

            //   showSnackbar(message, response.status === "success" ? "success" : "error");
            // });
        } else {
            showSnackbar("Invalid selection", "error");
        }

        // if (value === 'pending') {
        //   tc_upload.getPendingRecord(payload, (response) => {
        //     if (response.status === "success") {
        //       showSnackbar("Record Upload successfully!", "success");
        //     } else {
        //       showSnackbar("Something Went Wrong", "error");
        //     }
        //   })
        // } else if (value === 'completed') {
        //   tc_upload.getCompletedRecord(payload, (response) => {
        //     if (response.status === "success") {
        //       showSnackbar("Record Upload successfully!", "success");
        //     } else {
        //       showSnackbar("Something Went Wrong", "error");
        //     }
        //   })
        // }
        // else if (value === 'history') {
        //   tc_upload.getHistoryRecord(payload, (response) => {
        //     if (response.status === "success") {
        //       showSnackbar("Record Upload successfully!", "success");
        //     } else {
        //       showSnackbar("Something Went Wrong", "error");
        //     }
        //   })
        // } else if (value === 'reports') {
        //   tc_upload.getReportsRecord(payload, (response) => {
        //     if (response.status === "success") {
        //       showSnackbar("Record Upload successfully!", "success");
        //     } else {
        //       showSnackbar("Something Went Wrong", "error");
        //     }
        //   })
        // }

    }


    return (
        <>
            <Grid container spacing={4} style={{ height: "100%" }}>
                <Grid item xs={12}>
                    <Box
                        className='app-chat'
                        sx={{
                            width: '100%',
                            height: "100%",

                            // display: 'flex',
                            borderRadius: 1,
                            overflow: 'hidden',
                            position: 'relative',
                            backgroundColor: 'background.paper',
                            boxShadow: skin === 'bordered' ? 0 : 6,
                            ...(skin === 'bordered' && { border: `1px solid ${theme.palette.divider}` })
                        }}
                    >
                        <Upload_excel />
                    </Box>
                </Grid>
            </Grid >
        </>
    )
}



export default index



// pending teb :: default todays record ,
